var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4369 5.34297C12.9198 5.34297 13.1213 4.72266 12.7291 4.43672L6.76195 0.0960935C6.67673 0.033659 6.57384 0 6.4682 0C6.36256 0 6.25966 0.033659 6.17445 0.0960935L0.207258 4.43672C-0.184929 4.72109 0.0166333 5.34297 0.501008 5.34297H1.4682V11.1867H0.343196C0.274446 11.1867 0.218196 11.243 0.218196 11.3117V12.1242C0.218196 12.193 0.274446 12.2492 0.343196 12.2492H12.5932C12.6619 12.2492 12.7182 12.193 12.7182 12.1242V11.3117C12.7182 11.243 12.6619 11.1867 12.5932 11.1867H11.4682V5.34297H12.4369ZM6.4682 1.19766L10.7041 4.27891H2.23226L6.4682 1.19766ZM2.5932 5.34297H4.42132V11.1867H2.5932V5.34297ZM5.54632 5.34297H7.37445V11.1867H5.54632V5.34297ZM10.3432 11.1867H8.49944V5.34297H10.3432V11.1867Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.c0a9047fbaf725a95c8b697877abfb8a.svg";
export { ForwardRef as ReactComponent };